const SOCIAL_PROVIDERS = [
    {url: 'https://plus.google.com/108306936820925170087/', className: 'google'},
    {url: 'https://twitter.com/fiverr', className: 'twitter'},
    {url: 'https://www.facebook.com/fiverr', className: 'facebook'},
    {url: 'https://www.linkedin.com/company/fiverr-com', className: 'linkedin'},
    {url: 'https://www.pinterest.com/fiverr', className: 'pinterest'},
    {url: 'https://instagram.com/fiverr', className: 'instagram'}
];

export { SOCIAL_PROVIDERS };



// WEBPACK FOOTER //
// ./src/consts.js